import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "color"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { SvgIcon } from '@mui/material';
import { StyledIcon } from './icon.styles';
import { jsx as _jsx } from "react/jsx-runtime";
export var Icon = function Icon(_ref) {
  var className = _ref.className,
    color = _ref.color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(SvgIcon, {
    component: "i",
    inheritViewBox: true,
    className: className,
    color: color,
    children: /*#__PURE__*/_jsx(StyledIcon, _objectSpread({
      color: color
    }, props))
  });
};